export enum DatePickerFormat {
  DateOnly = 'dd-MM-yyyy',
  DateOnlyShortMonth = 'dd MMM yyyy',
  OmitDateShortMonth = 'MMM yyyy',
}
